export class PrintBarCodeModel {
  idsObject: number[] = [];
  grande: boolean;
  numeroCopie: number;
}
